export default function createDeferred<T>() {
  let resolve: (v?: any) => void = () => {};
  let reject: (reason?: string) => void = () => {};
  const promise = new Promise<T>((r, rj) => {
    resolve = r;
    reject = rj;
  });
  return {
    promise,
    resolve,
    reject,
  };
}
